import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createSubSpace } from "../../../redux/actions/subSpaces";
import Select from "react-select"; // Import React-Select
import { toast } from "react-toastify";

toast.configure();

const AddSubSpace = ({ open, handleClose, listingId, amenityOptions }) => {
  const [subSpaceData, setSubSpaceData] = useState({
    subSpaceHeight: "",
    subSpaceWidth: "",
    subSpaceLength: "",
    weeklyRate: "",
    monthlyRate: "",
    quantity: "",
    amenities: [], // Array for storing selected amenities
  });

  const dispatch = useDispatch();

  // Handle input changes for text fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSubSpaceData({
      ...subSpaceData,
      [name]: value,
    });
  };

  // Handle changes for React-Select multi-select dropdown
  const handleAmenityChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];
    setSubSpaceData((prev) => ({
      ...prev,
      amenities: selectedValues, // Update the amenities with selected values
    }));
  };

  // Handle form submission
  const handleSubmit = async () => {
    const dataToSubmit = {
      listingId,
      ...subSpaceData,
    };

    try {
      // Dispatch data to Redux or make API call
      await dispatch(createSubSpace(dataToSubmit));
      toast.success("Sub Space added successfully!");
      handleClose(); // Close modal on success
    } catch (error) {
      toast.error("Failed to add Sub Space. Please try again.");
    }
  };

  // React-Select options format
  const dropdownOptions = amenityOptions.map((option) => ({
    value: option.id,
    label: option.name,
  }));

  return (
    <div className={`modal ${open ? "show" : ""}`} style={{ display: open ? "block" : "none" }} tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
          </div>
          <div className="modal-body">
            <form>
              {/* Input fields for subSpaceData */}
              <div className="mb-3">
                <label htmlFor="subSpaceHeight" className="form-label">Sub Space Height</label>
                <input
                  type="number"
                  className="form-control"
                  id="subSpaceHeight"
                  name="subSpaceHeight"
                  value={subSpaceData.subSpaceHeight}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="subSpaceWidth" className="form-label">Sub Space Width</label>
                <input
                  type="number"
                  className="form-control"
                  id="subSpaceWidth"
                  name="subSpaceWidth"
                  value={subSpaceData.subSpaceWidth}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="subSpaceLength" className="form-label">Sub Space Length</label>
                <input
                  type="number"
                  className="form-control"
                  id="subSpaceLength"
                  name="subSpaceLength"
                  value={subSpaceData.subSpaceLength}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="weeklyRate" className="form-label">Weekly Rate</label>
                <input
                  type="number"
                  className="form-control"
                  id="weeklyRate"
                  name="weeklyRate"
                  value={subSpaceData.weeklyRate}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="monthlyRate" className="form-label">Monthly Rate</label>
                <input
                  type="number"
                  className="form-control"
                  id="monthlyRate"
                  name="monthlyRate"
                  value={subSpaceData.monthlyRate}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="quantity" className="form-label">Quantity</label>
                <input
                  type="number"
                  className="form-control"
                  id="quantity"
                  name="quantity"
                  value={subSpaceData.quantity}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="amenities" className="form-label">Amenities</label>
                <Select
                  id="amenities"
                  name="amenities"
                  options={dropdownOptions} // Dropdown options
                  isMulti // Enable multiple selection
                  value={dropdownOptions.filter((option) => subSpaceData.amenities.includes(option.value))} // Preselect values
                  onChange={handleAmenityChange} // Handle changes
                  placeholder="Select amenities"
                />
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Close</button>
            <button type="button" className="btn btn-primary" onClick={handleSubmit}>Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSubSpace;
